export default __webpack_public_path__ + "static/media/close.30508a6d.svg";